import { Avatar, Grid, Paper, Typography } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import React, { Component, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import i18n from "../../../../i18nextInitiator";
import Divider from "../../Divider";
import { compose } from "redux";
import { connect } from "react-redux";
import DriverInfo from "./DriverInfo";
import MoreProvidersDetailBtn from "./MoreProvidersDetailBtn";
import RatingComponent from "../../Comment/RatingComponent";
import withStyles from "@material-ui/core/styles/withStyles";
import Conditional from "../../Conditional";

/**
 * translate function.
 * @type {TFunction}
 */
const t = i18n.getFixedT("fa", "general");
/**
 * JSS
 * @type {(props?: any) => ClassNameMap<"paper"|"secPlateBox"|"plateBox"|"avatar"|"plateIran">}
 */
const styles = (theme) => ({
  paper: {
    backgroundColor: theme.palette.primary.light,
    border: "solid 1px #a9aed0",
    padding: "1rem .5rem",
    width: "100%",
    boxShadow: "none",
  },
  avatar: {
    height: 50,
    width: 50,
  },
  leftBox: {
    "& > *": {
      margin: ".2rem 0",
    },
  },
});
/**
 * maps redux states to component props.
 * @param state
 */
const mapStateToProps = (state) => ({ ...state.invoice.bill });

/**
 * This Component Represents Providers information Box (Car Plate, Names, etc.)
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
class ProviderInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workerDetails: !!props.commentPage,
    };
  }

  toggleWorkerDetails = () => {
    this.setState({ workerDetails: !this.state.workerDetails });
  };

  render() {
    const {
      props: {
        classes,
        workers = [],
        driver,
        commentPage,
        driver: { avatar } = {},
      },
      state: { workerDetails } = {},
    } = this;

    return (
      <Paper className={classes.paper}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container justifyContent={"space-between"}>
              <Grid item>
                <Grid container justifyContent={"flex-start"} spacing={2}>
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid item>
                        <Avatar
                          className={classes.avatar}
                          src={avatar}
                          size=""
                        />
                      </Grid>
                      {driver ? (
                        <Grid item style={{ margin: "0 .5rem" }}>
                          <Typography>
                            {`${driver.name} (${t("driver")})` || <Skeleton />}
                          </Typography>
                          {/* <Typography color="textSecondary" variant="subtitle2">
                            {driver.car_color || <Skeleton />}
                          </Typography> */}
                        </Grid>
                      ) : (
                        <Grid item style={{ margin: "0 .5rem" }}>
                          <Skeleton width={100} />
                          <Skeleton width={100} />
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {commentPage ? (
                <RatingComponent key={1} />
              ) : (
                <DriverInfo driver={driver} workerDetails={workerDetails} />
              )}
            </Grid>
          </Grid>
          {workerDetails && (
            <>
              <Divider />
              {workers.sort((a, b) => (a.id > b.id ? 1 : -1)) &&
                workers.map((worker) => {
                  return (
                    <Grid key={worker.id} item xs={12}>
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={1}
                      >
                        <Grid item>
                          <Grid container>
                            <Grid item>
                              <Avatar
                                className={classes.avatar}
                                src={
                                  worker ? worker.avatar : "/borken-image.jpg"
                                }
                                size=""
                              />
                            </Grid>
                            {driver ? (
                              <Grid item style={{ margin: "0 .5rem" }}>
                                <Typography>
                                  {`${worker.name} (${t("worker.name")})` || (
                                    <Skeleton />
                                  )}
                                </Typography>
                              </Grid>
                            ) : (
                              <Grid item style={{ margin: "0 .5rem" }}>
                                <Skeleton width={100} />
                                <Skeleton width={100} />
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                        <Grid item>
                          <Conditional condition={commentPage}>
                            <RatingComponent
                              key={worker.id}
                              workerId={worker.id}
                            />
                          </Conditional>
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                })}
            </>
          )}

          <MoreProvidersDetailBtn
            workerDetails={workerDetails}
            toggleWorkerDetails={this.toggleWorkerDetails}
          />
        </Grid>
      </Paper>
    );
  }
}

export default compose(
  withRouter,
  connect(mapStateToProps),
  withStyles(styles)
)(ProviderInfo);
